(() => {
  if (window.kbsCorporateGiftingLoaded) return;
  window.kbsCorporateGiftingLoaded = true;

  function initialise(scope = document) {
    scope.querySelectorAll('[data-gift-product]').forEach(product => {
      if (product.dataset.giftInitialised) return;
      product.dataset.giftInitialised = 'true';
      const pricing = product.querySelector('[data-gift-pricing]');
      const quantity = product.querySelector('[data-gift-quantity]');
      const output = product.querySelector('[data-gift-total]');
      const error = product.querySelector('[data-gift-error]');
      const selector = product.querySelector('[data-gift-variant]');
      const quoteLink = product.querySelector('[data-gift-quote-link]');
      const unitPrice = Number(pricing?.dataset.priceCents);
      const minimum = Number(pricing?.dataset.moq);
      const increment = Number(pricing?.dataset.increment);
      let formatter;
      try {
        formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: pricing?.dataset.currency
        });
      } catch {
        formatter = null;
      }

      function update() {
        if (!quantity || !output) return;
        const amount = Number(quantity.value);
        const valid = Number.isSafeInteger(amount) && amount >= minimum && (amount - minimum) % increment === 0;
        quantity.setCustomValidity(valid ? '' : error?.textContent.trim() || 'Invalid quantity');
        if (error) error.hidden = valid;
        output.textContent = valid && formatter && Number.isSafeInteger(amount * unitPrice)
          ? formatter.format(amount * unitPrice / 100) : '';
        if (quoteLink) quoteLink.setAttribute('aria-disabled', String(!valid));
        document.querySelectorAll('[data-gift-enquiry]').forEach(form => {
          const field = form.querySelector('[data-gift-form-quantity]');
          if (field && valid) field.value = amount;
        });
      }

      quantity?.addEventListener('input', update);
      quoteLink?.addEventListener('click', event => {
        if (quantity && !quantity.reportValidity()) event.preventDefault();
      });
      selector?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selector.value);
        window.location.assign(url.toString());
      });
      update();
    });

    scope.querySelectorAll('[data-gift-enquiry]').forEach(form => {
      if (form.dataset.giftInitialised) return;
      form.dataset.giftInitialised = 'true';
      const body = form.querySelector('[data-gift-body]');
      const field = form.querySelector('[data-gift-form-quantity]');
      const source = document.querySelector('[data-gift-product] [data-gift-pricing]');
      if (source && field && Number(source.dataset.moq) > 0) {
        field.min = source.dataset.moq;
        field.step = source.dataset.increment;
        field.value = source.dataset.moq;
      }
      const initialBody = body?.value || '';
      form.addEventListener('submit', event => {
        if (field && !field.reportValidity()) {
          event.preventDefault();
          return;
        }
        if (body) {
          const lines = [...form.querySelectorAll('[data-gift-summary]')].map(input =>
            `${input.dataset.giftSummary}: ${input.value.trim()}`
          );
          body.value = [initialBody, ...lines].filter(Boolean).join('\n');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
